import { render } from "./smeta_zakupshik.vue?vue&type=template&id=2993c1af&scoped=true"
import script from "./smeta_zakupshik.vue?vue&type=script&lang=js"
export * from "./smeta_zakupshik.vue?vue&type=script&lang=js"

import "./smeta_zakupshik.vue?vue&type=style&index=0&id=2993c1af&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2993c1af"]])

export default __exports__